
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aviso-a-clientes",
      function () {
        return require("private-next-pages/aviso-a-clientes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aviso-a-clientes"])
      });
    }
  